var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { LAYOUT } from '@/stores/defs';
var layoutMixin = {
    computed: __assign({}, mapGetters({
        getRouteLayout: LAYOUT.GET_ROUTE_LEVEL,
    }), { layout_hasSidebar: function () {
            var $appConstants = this.$appConstants;
            var layoutOptions = $appConstants.layoutOptions;
            var sidebar = layoutOptions.sidebar;
            return sidebar;
        } }),
    methods: __assign({}, mapActions({
        setRouteLayout: LAYOUT.SET_ROUTE_LEVEL,
    }), { layout_checkDynamicPadding: function () {
            var isMobile = this.$mq !== 'desktop';
            if (!isMobile) {
                return false;
            }
            var $appConstants = this.$appConstants;
            var translateHeaderYMobile = $appConstants.header.translateHeaderYMobile;
            var hasMovingHeader = translateHeaderYMobile !== '0';
            return isMobile && hasMovingHeader;
        } }),
};
export default layoutMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/layoutMixin.ts
// module id = cT2I
// module chunks = 18